<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.5 7.91675L8.74996 12.5001L7.08329 10.8334M17.7083 10.0001C17.7083 14.2573 14.2572 17.7084 9.99996 17.7084C5.74276 17.7084 2.29163 14.2573 2.29163 10.0001C2.29163 5.74289 5.74276 2.29175 9.99996 2.29175C14.2572 2.29175 17.7083 5.74289 17.7083 10.0001Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckCircleIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
